<template>
    <div class="tabbed-menu-item w-100 d-flex justify-content-center align-items-center py-5" :class="{'selected': current}" @click="openRelatedTab">
        <slot></slot>
    </div>
    
</template>

<script>
    export default {
        props: {
            for: {type: String, required: true},
            selected: Boolean,
        },

        data: function () {
            return {
                current: this.selected,
            }
        },

        created: function () {
            bus.$on( 'tab-content-open', ( id ) => {
                this.current = this.for == id;
            });
        },

        mounted: function () {
            bus.$on('map-initialized', ( google ) => {
                if ( this.current ) {
                    setTimeout( () => {
                        bus.$emit( 'tab-content-open', this.for );
                        bus.$emit( 'tabbed-menu-item-selected', this.for );
                    }, 100 );
                }
            });
        },

        methods: {
            openRelatedTab: function ( ) {
                if ( ! this.current ) {
                    bus.$emit( 'tab-content-open', this.for );
                    bus.$emit( 'tabbed-menu-item-selected', this.for );
                }
            },
        }
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    .tabbed-menu-item {
        color: $gray-darker;

        &:hover {
            background-color: #f1f1f1;
        }

        &.selected {
            background-color: $green-light;
            color: $white;
            position: relative;

            &:after {
                content: '';
                
                position: absolute;
                bottom: -1px;
                left: 50%;
                transform: translate3d( -50%, 0, 0 );
                z-index: 100;

                width: 0;
                height: 0;
                border-style: solid;
                border-width: 0 10px 10px 10px;
                border-color: transparent transparent #ffffff transparent;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TabbedMenuItem.vue